import { simplePath } from "../../utils.js";
const GET_ORG_APPLICATION_LIST_PATH = '/v2/organization/:organization/application-list';
function get_org_application_list_path(params) {
    return simplePath(GET_ORG_APPLICATION_LIST_PATH, params);
}
export { GET_ORG_APPLICATION_LIST_PATH, get_org_application_list_path };
